import React, { PropsWithChildren } from 'react';
import { api } from '../services/api';
import moment from 'moment';

export interface IUser {
    nome: string;
    email: string;
    area: string;
    papel: number;
    mercado: string;
    permissoes: string[];
}

export interface IData {
    token: string;
    tokenDate: Date;
    user: IUser;
}

export interface IAuthContext {
    data: IData;
    loading: boolean;
    loadData(): void;
    login(token: string): void;
    logout(): void;
}

export const AuthContext = React.createContext({} as IAuthContext);

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const { Provider } = AuthContext;

    const [data, setData] = React.useState<IData>({} as IData);
    const [loading, setLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar informações do usuário.
     */
    async function loadData() {

        const data = window.localStorage.getItem('@pricememo:data');

        if (data) {

            const parsed = JSON.parse(data);

            const hours = moment().diff(moment(parsed.tokenDate), 'hours');

            if (hours >= 12) {
                clearData();
            } else {
                //Verificar se o token expirou
                try {
                    api.defaults.headers = {
                        'accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': parsed.token,
                    }
                    await api.get('auth/verify');
                    setData(parsed);
                } catch (error) {
                    alert("O token é inválido ou expirou!");
                    clearData();
                    window.close();
                }
            }

        }
        setLoading(false);
    }

    /**
     * Realizar login do usuário.
     * @param token     
     */
    async function login(token: string) {

        const response = await api.get(`auth/token/${token}`);

        const data = {
            token: response.data.token,
            tokenDate: new Date(),
            user: {
                nome: response.data.nome,
                email: response.data.email,
                area: response.data.area,
                papel: response.data.papel_id,
                mercado: response.data.mercado,
                permissoes: response.data.permissoes
            }
        }

        api.defaults.headers = {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': data.token,
        }

        window.localStorage.setItem('@pricememo:data', JSON.stringify(data));
        setData(data);
    }

    /**
     * Realizar logout do usuário.
     */
    async function logout() {
        await api.post('auth/logout');
        clearData();
        window.close();
    }

    /**
     * Limpar toda informação do Storage.
     */
    function clearData() {
        api.defaults.headers = {};
        window.localStorage.removeItem('@pricememo:data');
        setData({} as IData);
    }

    return (
        <Provider value={{ login, logout, data, loading, loadData }}>
            {children}
        </Provider>
    );
}

export const useAuth = () => { return React.useContext(AuthContext); };